<script setup>
import Form from '@/classes/Form'

// define props
const props = defineProps({
  form: {
    type: Form,
    required: true,
  }
})
// define emits
const emit = defineEmits(['submit'])
// define methods
const submit = () => {
  emit('submit')
}
</script>

<template>
  <h2>{{ $t('labels.already_customer') }}</h2>
  <div class="form-group" :class="{'has-error': form.errors.has('email') }">
    <label class="control-label" for="email">{{ $t('forms.email') }}*:</label>
    <input
      v-model.trim="form.email"
      class="form-control input-sm"
      type="email"
      key="input-email"
      :placeholder='$t("forms.placeholders.email")'>
  </div>
  <div class="form-group">
    <label for="password">{{ $t('forms.password') }}*:</label>
    <input
      type="password"
      class="form-control input-sm"
      id="password"
      v-model.trim="form.password"
      :placeholder='$t("forms.placeholders.password")'
      required>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-primary" @click="submit">
      {{ $t("labels.login") }}
    </button>
    <p style="margin-top: 8px">
      <a href="/password/reset" target="_blank">{{ $t("labels.password_reset") }}</a>
    </p>
  </div>
</template>